// extracted by mini-css-extract-plugin
export default {"selectInitialProduct":"ActionScreenProduceTransformationFromProductStock_selectInitialProduct__Qymn6"};